import axios from "axios";
import {
  CONNECTIQ_CHAT_ROUTE,
  CONNECTIQ_GET_SESSIONS_ROUTE,
  CONNECTIQ_GET_MESSAGES_ROUTE,
  CONNECTIQ_DELETE_SESSION_ROUTE,
} from "./apiRoutes";

// Send a message and get AI response
export const connectiqChat = (userSlug, message, scope, sessionId) => {
  const postData = new FormData();
  postData.append("user_slug", userSlug);
  postData.append("message", message);
  postData.append("scope", scope);
  if (sessionId) postData.append("session_id", sessionId);
  return axios.post(CONNECTIQ_CHAT_ROUTE, postData).catch(() => false);
};

// Get all sessions for sidebar history
export const connectiqGetSessions = (userSlug) => {
  const postData = new FormData();
  postData.append("user_slug", userSlug);
  return axios.post(CONNECTIQ_GET_SESSIONS_ROUTE, postData).catch(() => false);
};

// Get all messages for a session
export const connectiqGetMessages = (userSlug, sessionId) => {
  const postData = new FormData();
  postData.append("user_slug", userSlug);
  postData.append("session_id", sessionId);
  return axios.post(CONNECTIQ_GET_MESSAGES_ROUTE, postData).catch(() => false);
};

// Delete a session
export const connectiqDeleteSession = (userSlug, sessionId) => {
  const postData = new FormData();
  postData.append("user_slug", userSlug);
  postData.append("session_id", sessionId);
  return axios
    .post(CONNECTIQ_DELETE_SESSION_ROUTE, postData)
    .catch(() => false);
};
